import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[hsClickPreventDefault]'
})
export class ClickPreventDefaultDirective {

  @HostListener('click', ['$event']) onClick(event: Event): void {
    event.preventDefault();
  }
}
